/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/*
Author: Rendra Pramulia
*/

import React from 'react';
import { useDispatch } from 'react-redux';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

import ModalTopRounded from '@components/modal/ModalTopRounded';
import Colors from '@global/colors';
import { isWeb, isMobileWeb } from '@global/screens';
import { showPopup } from '@/store/modal';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';

const ModalPricelistUpload = (props) => {
  const dispatch = useDispatch();

  const addPricelist = () => {
    dispatch(showPopup({ name: 'pricelistUpload', value: false }));
    props.navigation.replace('PricelistDetailScreen');
  };

  const chooseFile = async () => {
    dispatch(showPopup({ name: 'pricelistUpload', value: false }));
    dispatch(
      showPopup({
        name: 'showImportModalPricelist',
        value: true,
      }),
    );
  };

  return (
    <ModalTopRounded
      title="Add Pricelist"
      visible={props.show}
      maxWidth={isWeb && !isMobileWeb ? 500 : '100%'}
      onClose={() =>
        dispatch(showPopup({ name: 'pricelistUpload', value: false }))
      }
      children={
        <View style={styles.productAdd}>
          <TouchableOpacity
            activeOpacity={0.6}
            style={styles.itemOption}
            onPress={() => addPricelist()}>
            <Image
              style={{ width: 43, height: 43 }}
              width={43}
              height={43}
              source={require('@assets/img/icons/add-product.png')}
            />
            <SociollaText style={styles.itemText}>Add Manually</SociollaText>
          </TouchableOpacity>
          <TouchableOpacity
            activeOpacity={0.6}
            style={styles.itemOption}
            onPress={() => chooseFile()}>
            <Image
              // eslint-disable-next-line react-native/no-inline-styles
              style={{ width: 35, height: 43 }}
              width={35}
              height={43}
              source={require('@assets/img/icons/add-from-csv.png')}
            />
            <SociollaText style={styles.itemText}>Import CSV</SociollaText>
          </TouchableOpacity>
        </View>
      }
    />
  );
};

const styles = StyleSheet.create({
  productAdd: {
    width: '100%',
    paddingHorizontal: isWeb ? 25 : 15,
    paddingTop: isWeb ? 25 : 15,
    paddingBottom: isWeb ? 40 : 15,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  itemOption: {
    padding: 15,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
    borderColor: Colors.grey0,
    borderWidth: 1,
    marginHorizontal: isWeb ? 15 : 10,
  },
  itemText: {
    fontSize: 14,
    marginTop: 15,
  },
});

export default ModalPricelistUpload;
